var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 70,
    viewBox: "0 0 104 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_9399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.9237 47.2783H19.0078V52.249H86.9237V47.2783Z",
    fill: "#1C5080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9237 9.10156H19.0078V47.2783H86.9237V9.10156Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 12H23V44H83V12Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3225 62.8443H42.6854C41.9505 62.8443 41.3555 62.2089 41.3555 61.4241C41.3555 60.6393 41.9505 60.0039 42.6854 60.0039H61.3225C62.0575 60.0039 62.6525 60.6393 62.6525 61.4241C62.6525 62.2089 62.0575 62.8443 61.3225 62.8443Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2927 0.000976562H9.71724C7.3723 0.000976562 5.46484 2.03782 5.46484 4.54182V60.8632H98.5451V4.54182C98.5451 2.03782 96.6376 0.000976562 94.2927 0.000976562ZM93.9427 57.5183H10.0497V3.90648H93.9427V57.5183Z",
    fill: "#1C5080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.069 66.339H4.93879C2.22635 66.339 0.00390625 63.9658 0.00390625 61.0693V62.639C0.00390625 65.5354 2.22635 67.9086 4.93879 67.9086H38.958C38.958 67.9273 38.958 67.9273 38.958 67.946V68.5814C38.958 69.3662 39.553 70.0015 40.2879 70.0015H63.7199C64.4549 70.0015 65.0498 69.3662 65.0498 68.5814V67.946C65.0498 67.9273 65.0498 67.9273 65.0498 67.9086H99.069C101.781 67.9086 104.004 65.5354 104.004 62.639V61.0693C104.004 63.9658 101.781 66.339 99.069 66.339Z",
    fill: "#1F8ACB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5366 29.6869C52.73 30.1704 53.4552 30.7505 54.3255 31.089C57.468 32.2493 58.8218 32.1526 59.7887 35.0535C58.435 36.5039 56.7912 37.6642 54.9056 38.3894H44.4626C42.7705 37.7126 41.2233 36.6489 39.918 35.3919C40.0147 30.3638 45.5746 33.2646 46.88 29.6869C47.1217 29.01 47.1217 27.9464 46.9767 27.2695L49.6841 27.3179L52.3916 27.2695C52.2465 27.9464 52.2465 29.01 52.5366 29.6869Z",
    fill: "#F0C17D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5361 29.6869C52.6811 30.0737 53.1646 30.5571 53.8415 30.8472C57.0807 32.2493 59.4498 32.201 59.7882 35.0535C58.4345 36.5039 56.7906 37.6642 54.9051 38.3894H49.6836V27.3179H49.7319L52.4394 27.2695C52.246 27.9464 52.246 29.01 52.5361 29.6869Z",
    fill: "#E0AF6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4453 30.1709L49.6846 30.5093L53.0205 30.1709L52.6821 40.4205H46.7837L46.4453 30.1709Z",
    fill: "#A0E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7306 28.8651C49.1021 28.8651 48.8604 28.8651 48.5219 28.7201C48.2319 28.575 48.0868 28.285 47.7 27.8982C47.3616 27.5597 46.7331 27.2213 46.588 26.8829C46.3947 26.4478 46.443 25.9643 46.3463 25.3358C46.0079 25.5292 45.6694 24.6106 45.6211 24.2721C45.5244 23.837 45.186 23.0634 45.0893 22.58C45.0409 22.2899 45.0893 22.0482 45.186 21.9998C45.3794 21.8548 45.6211 21.9515 45.9595 22.3866C45.9595 21.7581 45.9112 21.2263 46.0079 20.7428C46.443 18.1804 52.6798 16.7783 53.3567 20.7428C53.4534 21.2263 53.4534 21.7581 53.405 22.3866C53.7434 21.9515 53.9368 21.8548 54.1786 21.9998C54.2753 22.0965 54.3236 22.2899 54.2753 22.58C54.1786 23.0634 53.8401 23.837 53.7434 24.2721C53.6951 24.5622 53.3567 25.4808 53.0182 25.3358C52.9699 25.9643 52.9699 26.4478 52.8248 26.8829C52.6798 27.2697 52.0513 27.6081 51.7129 27.9465C51.3261 28.3333 51.181 28.6234 50.891 28.7684C50.5525 28.8651 50.2624 28.8651 49.7306 28.8651Z",
    fill: "#FFDBA7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7319 28.8649H49.6836V18.2768C51.3274 18.1318 53.0196 18.7603 53.358 20.6942C53.4547 21.1777 53.4547 21.7095 53.4063 22.338C53.7448 21.9029 53.9382 21.8062 54.1799 21.9512C54.2766 22.0479 54.3249 22.2413 54.2766 22.5314C54.1799 23.0149 53.8415 23.7884 53.7448 24.2235C53.6964 24.5136 53.358 25.4322 53.0196 25.2872C52.9712 25.9157 52.9712 26.3992 52.8262 26.8343C52.6811 27.2211 52.0526 27.5595 51.7142 27.8979C51.3274 28.2847 51.1824 28.5748 50.8923 28.7198C50.5538 28.8649 50.2638 28.8649 49.7319 28.8649Z",
    fill: "#F0C17D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3403 29.0107C52.437 29.5909 52.582 29.8326 52.9688 30.1227L51.325 32.8785L49.6328 30.5095C50.5031 30.026 52.0502 29.4459 52.3403 29.0107Z",
    fill: "#DBFBF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.023 29.0107C46.9264 29.5909 46.7813 29.8326 46.3945 30.1227L48.0383 32.8785L49.7788 30.4612C48.8602 30.026 47.3131 29.4459 47.023 29.0107Z",
    fill: "#DBFBF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4455 30.1221C44.7533 31.6208 41.369 30.8956 39.7252 33.313C38.8066 34.6184 39.0483 37.2775 39 40.42H48.7662C48.0409 37.7609 47.074 31.9593 46.4455 30.1221Z",
    fill: "#134861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7785 30.6055L50.6004 31.8625V32.1526L49.8752 32.8778L50.6487 34.1348L50.407 40.42H49.0049L48.7148 34.1348L49.4884 32.8778L48.7632 32.1526V31.8625L49.5851 30.6055H49.7785Z",
    fill: "#266590"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7803 30.6055L50.6022 31.8625V32.1526L49.877 32.8778L50.6505 34.1348L50.4088 40.42H49.6836V30.6055H49.7803Z",
    fill: "#134861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4475 30.1221C46.1091 30.4122 45.4322 30.7506 44.8037 30.9923L44.707 34.5217L46.2541 34.3766L45.3839 35.537L46.7376 40.42H48.7682C48.043 37.7609 47.076 31.9593 46.4475 30.1221Z",
    fill: "#266590"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8786 20.0662C46.3468 20.6947 46.2017 23.1604 46.2501 24.0307C45.3798 20.7914 44.8963 18.4707 46.8302 17.0203C49.3443 15.1348 52.1968 16.2951 52.6803 17.0687C54.5658 18.084 53.8889 20.9848 53.3571 23.5472C53.3571 22.5803 52.8736 20.2112 52.4869 19.196C51.0364 18.3257 48.2323 20.9848 46.8786 20.0662Z",
    fill: "#703100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6836 16.0046C51.1824 15.9562 52.391 16.5847 52.6811 17.0682C54.5667 18.0835 53.8898 20.9844 53.358 23.5468C53.358 22.5798 52.8745 20.2108 52.4877 19.1955C51.7625 18.7604 50.7472 19.1955 49.6836 19.6306V16.0046Z",
    fill: "#4F2200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9261 30.1221C54.6183 31.6208 58.0026 30.8956 59.6464 33.313C60.565 34.6184 60.2749 37.2775 60.3716 40.42H50.6055C51.3307 37.7609 52.2976 31.9593 52.9261 30.1221Z",
    fill: "#0F303F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9261 30.1221C53.1195 30.3155 54.5699 30.9923 54.5699 30.9923L54.6666 34.5217L53.1195 34.3766L53.9898 35.537L52.7328 40.42H50.6055C51.3307 37.7609 52.2976 31.9593 52.9261 30.1221Z",
    fill: "#134861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9685 32.492L57.9532 37.5201L57.5664 38.5837L60.2255 39.0672L60.6123 37.3267L61.2891 34.3775C61.9177 33.9424 62.1111 33.1688 62.6429 32.5403C63.078 32.0568 63.4648 31.8151 63.6098 31.2833C63.6582 30.9932 63.6582 30.6548 63.3681 30.5097C63.6098 30.3647 63.5615 30.123 63.5131 29.9296C63.4648 29.7362 63.4164 29.5428 63.1263 29.5911C63.3197 29.4461 63.3197 29.3494 63.3197 29.156C63.2714 29.011 63.1747 28.7692 63.0297 28.6725C62.933 28.6242 62.7879 28.6242 62.6429 28.6242L62.5945 28.4308C62.7879 28.2374 63.1747 28.0924 63.223 27.8506C63.3197 27.5605 63.078 26.8837 62.4011 27.1254L61.1441 27.6089L59.5486 27.9473C59.2586 28.4308 59.0652 28.8659 58.7267 29.3977C58.3883 29.8812 58.6784 30.268 58.6784 30.8965C58.7751 31.5734 58.7751 32.1535 58.9685 32.492Z",
    fill: "#FFDBA7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7877 32.1535C63.3195 31.7184 63.4646 31.8151 63.6096 31.2833C63.658 30.9932 63.658 30.6548 63.3679 30.5097C63.6096 30.3647 63.5613 30.123 63.5129 29.9296C63.4646 29.7362 63.4162 29.5428 63.1261 29.5911C63.3195 29.4461 63.3195 29.3494 63.3195 29.156C63.2712 29.011 63.1745 28.7692 63.0295 28.6725C62.9328 28.6242 62.7877 28.6242 62.6427 28.6242L62.5943 28.4308C62.7877 28.2374 63.1745 28.0924 63.2228 27.8506C63.3195 27.5605 63.0778 26.8837 62.4009 27.1254L61.1439 27.6089L60.2737 27.8023C59.065 29.2527 59.9836 28.9626 60.0319 30.3647C60.0803 31.6217 59.7418 32.5403 60.8538 32.5403C61.7724 32.5403 62.3042 32.5887 62.7877 32.1535Z",
    fill: "#EEBE69"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4219 40.4214L57.8087 34.1846L61.8215 34.9098L61.5797 40.4214H57.4219Z",
    fill: "#134861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0592 21.082C65.1075 23.9345 64.5757 28.5275 61.2881 28.5275C58.0488 28.5759 57.4203 23.9345 57.517 21.082H61.2881H65.0592Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.564 20.8398H65.0095C65.2513 20.8398 65.4446 21.0332 65.4446 21.275C65.4446 21.5167 65.2513 21.7101 65.0095 21.7101H57.564C57.3223 21.7101 57.1289 21.5167 57.1289 21.275C57.1289 21.0332 57.3223 20.8398 57.564 20.8398Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2068 27.8984H60.418V31.8146H62.2068V27.8984Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0962 31.6211H64.4781C64.6715 31.6211 64.8165 31.7661 64.8165 31.9595V35.3438C64.8165 35.5372 64.6715 35.6823 64.4781 35.6823H58.0962C57.9029 35.6823 57.7578 35.5372 57.7578 35.3438V31.9595C57.7578 31.7661 57.9029 31.6211 58.0962 31.6211Z",
    fill: "#14BAC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0602 35.0537H57.5664V35.8273H65.0602V35.0537Z",
    fill: "#D43726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2692 32.3467H59.3047V34.474H63.2692V32.3467Z",
    fill: "#D43726"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0602 21.082C65.1085 23.9345 64.5767 28.5275 61.2891 28.5275V21.082H65.0602Z",
    fill: "#FC9E0A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2891 20.8398H65.0118C65.2535 20.8398 65.4469 21.0332 65.4469 21.275C65.4469 21.5167 65.2535 21.7101 65.0118 21.7101H61.2891V20.8398Z",
    fill: "#FC9E0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1593 27.8984H61.2891V31.8146H62.1593V27.8984Z",
    fill: "#FC9E0A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2891 31.6211H64.5283C64.6734 31.6211 64.8184 31.7661 64.8184 31.9595V35.3438C64.8184 35.5372 64.6734 35.6823 64.5283 35.6823H61.2891V34.6186L62.0143 33.555L61.2891 32.4913V31.6211Z",
    fill: "#0EA8B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0118 35.0537H61.2891V35.8273H65.0118V35.0537Z",
    fill: "#BD3222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2713 32.3467H61.2891V34.474H63.2713V32.3467Z",
    fill: "#BD3222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1076 23.1119C64.9626 22.8218 65.0109 22.4834 65.1076 22.1933C66.0262 20.4528 68.4919 21.4681 67.9118 23.9821C67.67 24.9974 66.8965 25.8677 66.0746 26.3995C65.301 26.883 64.8175 26.883 64.4308 27.173C64.1407 27.4148 64.2374 27.8016 64.6725 27.7049C64.8175 27.6565 64.9626 27.7532 65.0109 27.8983C65.0593 28.0433 64.9626 28.1883 64.8175 28.2367C64.5275 28.3334 64.2857 28.285 64.1407 28.1883C63.6089 27.8983 63.6572 27.173 64.0923 26.7863C64.3824 26.4962 65.0593 26.4962 65.9295 25.916C66.6547 25.4325 67.2349 24.659 67.38 23.8371C67.8634 21.3714 65.301 21.3714 65.1076 23.1119Z",
    fill: "#FC9E0A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4696 23.1119C57.6147 22.8218 57.5663 22.4834 57.4696 22.1933C56.551 20.4528 54.0853 21.4681 54.6655 23.9821C54.9072 24.9974 55.6808 25.8677 56.5027 26.3995C57.2762 26.883 57.7597 26.883 58.1465 27.173C58.4366 27.4148 58.3399 27.8016 57.9047 27.7049C57.7597 27.6565 57.6147 27.7532 57.5663 27.8983C57.518 28.0433 57.6147 28.1883 57.7597 28.2367C58.0498 28.3334 58.2915 28.285 58.4366 28.1883C58.9684 27.8983 58.92 27.173 58.4849 26.7863C58.1948 26.4962 57.518 26.4962 56.6477 25.916C55.9225 25.4325 55.3423 24.659 55.1973 23.8371C54.7138 21.3714 57.2762 21.3714 57.4696 23.1119Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6074 31.283C63.704 31.0413 63.6557 30.6545 63.414 30.5095C62.9305 30.7029 62.3987 30.8962 61.9152 31.0413C61.7218 31.138 61.6251 31.4281 61.8185 31.6215C61.9635 31.7665 62.4954 31.6698 62.8821 31.6215C63.3656 31.5248 63.5107 31.4764 63.6074 31.283ZM63.414 30.4611H63.3173L63.1722 30.5578L62.1086 30.9446C61.7702 31.0896 61.2867 31.3314 61.0449 31.2347C60.8999 31.1863 60.8032 31.0896 60.8032 30.8479C60.8032 30.6545 60.8516 30.5095 61.0449 30.4611C61.8185 30.2194 62.5437 29.9293 63.2689 29.5909C63.4623 29.5909 63.5107 29.7843 63.559 29.9293C63.559 30.1227 63.6557 30.3644 63.414 30.4611ZM63.1722 29.5909C62.447 29.881 61.7702 30.171 60.9483 30.4611C60.5131 30.5578 60.3681 29.9776 60.7065 29.6876C60.8999 29.4942 61.5284 29.2041 62.0602 29.0107C62.3503 28.8657 62.5921 28.769 62.7855 28.7206C62.8821 28.7206 62.9788 28.7206 63.0272 28.769C63.1722 28.8173 63.2689 29.059 63.3173 29.2524C63.3656 29.3491 63.3173 29.4458 63.1722 29.5909ZM62.6888 28.4305C62.8821 28.2855 63.1722 28.1404 63.2206 27.9471C63.3173 27.657 63.0272 27.0285 62.6888 27.2218C62.447 27.3669 62.1569 27.5119 61.8185 27.7053C61.3834 27.9471 60.9483 28.2371 61.0933 28.6239C61.1416 28.8173 61.335 29.0107 61.6251 28.8657C62.1086 28.6723 62.3503 28.5756 62.6888 28.4305Z",
    fill: "#FFDBA7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5953 27.9473C59.2569 28.4307 59.1119 28.8659 58.7734 29.3977C58.435 29.8812 58.7251 30.2679 58.7251 30.8965C58.7251 31.0415 58.7251 31.1382 58.7734 31.2832C58.8701 31.1865 58.9668 31.1382 59.0152 31.0415C59.6437 30.4613 59.9821 30.0262 59.8854 29.2043C60.3205 29.4944 61.2391 29.5427 61.4325 29.2043C61.6259 28.8659 61.0941 28.6725 60.8524 28.5274C60.4172 28.2857 59.8854 28.044 59.5953 27.9473Z",
    fill: "#FFDBA7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_9399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcImg2);
export default __webpack_public_path__ + "static/media/proc-img-2.d4e3cce05b56ada96375758dd0765505.svg";
export { ForwardRef as ReactComponent };